<script lang="ts">
  import ProgressBar from "./ProgressBar.svelte";
  import { assetsProgress, assetsLoaded } from "../store/AppState";
  import { soundsLoaded } from "../utils/AudioManager";
  import { afterUpdate } from "svelte";
  import isMobile from "is-mobile";

  export let buttonClicked: boolean;

  let audioAssetsCount = 24 + 1 + 24 + 4;
  const backgroundAssetsCount = 1;
  const animationsAssetsCount = 24;
  const extraAssetsCount = 2;
  let giftsAssetsCount = 24;
  if (window.isClosed && !window.isShowroom) {
    giftsAssetsCount = 0;
    audioAssetsCount--;
  }

  let maxProgress = 0;
  if (isMobile()) {
    maxProgress =
      audioAssetsCount + animationsAssetsCount + (giftsAssetsCount / 24) * 3;
  } else {
    maxProgress =
      backgroundAssetsCount +
      animationsAssetsCount * 2 +
      extraAssetsCount +
      giftsAssetsCount;
  }

  $: progress = 0;

  afterUpdate(() => {
    progress = ($assetsProgress / maxProgress) * 100;
  });
</script>

{#if !$assetsLoaded || !$soundsLoaded}
  <ProgressBar {progress} {buttonClicked} />
{/if}
